import { render, staticRenderFns } from "./VDatePicker.vue?vue&type=template&id=6d80f0a5&scoped=true&"
import script from "./VDatePicker.vue?vue&type=script&lang=js&"
export * from "./VDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d80f0a5",
  null
  
)

export default component.exports